// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';

export const FETCH_IMAGES = 'v1/image/FETCH_IMAGES';

export type FetchImageSuccess = ApiSuccess<Image, *>;

type ImageParams = {
  journeyId: number,
  token: string,
};

// $FlowFixMe
export function fetchImages({journeyId, token}: ImageParams) {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };
  return {
    types: ASYNC_TYPES(FETCH_IMAGES),
    callAPI: () =>
      axios
        .get(
          `${cfg.bookingServiceUrl}/image/${journeyId}?width=1000&height=562`,
          config
        )
        .then((res) => res.data),
  };
}
